<template>
  <div>
    <el-form ref="form" size="mini" :model="data" status-icon :rules="formRules">
      <el-row class="item-title">
        <el-col :span="24">
          <span>页面展示模式</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="displayMode">
            <el-radio-group v-model="data.displayMode">
              <el-radio label="0">单标签</el-radio>
              <el-radio label="1">多标签</el-radio>
            </el-radio-group>
          </el-form-item>
          <span style="margin:0;">（选择</span>
          <span style="color:#FF8100;margin:0;">单标签</span>
          <span style="margin:0;">，则内容展示区域始终只有一个模块的页面打开；选择</span>
          <span style="color:#FF8100;margin:0;">多标签</span>
          <span style="margin:0;">，则可以多个模块的页面同时打开）</span>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>商城是否显示充值按钮</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="TopUp">
            <el-radio-group v-model="data.TopUp">
              <el-radio label="true">是</el-radio>
              <el-radio label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>商城是否启用混合支付</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="HybridPay">
            <el-radio-group v-model="data.HybridPay">
              <el-radio label="true">是</el-radio>
              <el-radio label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>销货单审核时是否自动发货</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="AutoDelivery">
              <el-radio-group v-model="data.AutoDelivery" @change="deliveryChange">
                <el-radio label="true">是</el-radio>
                <el-radio label="false">否</el-radio>
              </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>运费方式</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="Freight">
              <el-radio-group v-model="data.Freight">
                <el-radio label="0">按商品计算</el-radio>
                <el-radio label="1">整单运费</el-radio>
              </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>是否自动审核</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="AutoReview">
            <el-select style="margin-right:10px" size="mini" v-model="data.AutoReview">
                <el-option  label="是" :value="1"></el-option>
                <el-option  label="否" :value="0"></el-option>
            </el-select>
            <el-time-select
              v-if="data.AutoReview==1"
              v-model="data.AutoReviewTime"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:59'
              }"
              placeholder="选择时间">
            </el-time-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>是否自动发货</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="AutoSend">
            <el-select style="margin-right:10px" size="mini" v-model="data.AutoSend">
                <el-option  label="是" :value="1"></el-option>
                <el-option  label="否" :value="0"></el-option>
            </el-select>
            <el-time-select
              v-if="data.AutoSend==1"
              v-model="data.AutoSendTime"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:59'
              }"
              placeholder="选择时间">
            </el-time-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>是否自动收货</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="AutoReceive">
            <el-select style="margin-right:10px" size="mini" v-model="data.AutoReceive">
                <el-option  label="是" :value="1"></el-option>
                <el-option  label="否" :value="0"></el-option>
            </el-select>
            <el-time-select
              v-if="data.AutoReceive==1"
              v-model="data.AutoReceiveTime"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:59'
              }"
              placeholder="选择时间">
            </el-time-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>设置默认物流</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="DefaultLogistics">
            <el-select style="margin-right:10px" clearable size="mini" v-model="data.DefaultLogistics">
                <el-option v-for="(item,index) in logisticsList" :key="index"  :label="item.LogisticsName" :value="String(item.LogisticsId)"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>  
         <el-row class="item-title">
        <el-col :span="24">
          <span>商城起购金额</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="PurchaseAmount">
            <el-input v-model="data.PurchaseAmount"  @blur="onBlur(data,'PurchaseAmount')" @focus="onFocus(data,'PurchaseAmount')" type="number" placeholder="请输入商城起购金额"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>是否保存并更新库存</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="IsUpdateInventory">
            <el-select style="margin-right:10px" size="mini" v-model="data.IsUpdateInventory">
                <el-option  label="是" value="1"></el-option>
                <el-option  label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row> 
    </el-form>
    <el-alert title="数据保存成功后，需要重新登录才能生效" type="warning" :closable="false" />
    <div class="item-footer">
      <el-button type="primary" size="mini" style="width:80px;" @click="submit">保 存</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: {
        displayModeId: 0,
        displayMode: 0, //页面展示模式
        TopUpId:0,
        TopUp:'',
        HybridPayId:0,
        HybridPay:'',
        AutoDeliveryId:0,
        AutoDelivery:'',
        AutoSendId:"",
        AutoSend:"",
        AutoSendTime:"",
        AutoReviewId:"",
        AutoReview:"",
        IsUpdateInventory: "", //是否保存并更新库存
        IsUpdateInventoryId: "", 
        AutoReviewTime:"",
        AutoReceiveId:"",
        AutoReceive:"",
        AutoReceiveTime:"",
        DefaultLogisticsId:"",
        DefaultLogistics:"",
        PurchaseAmountId:"",
        PurchaseAmount:"0",
        AutoDelivery_inputValue: "",
        FreightId:"",
        Freight:""
      },
      logisticsList:[],
      isNull: false,
      saveData: [],
      formRules: {
        // displayMode: [{ required: true, message: "请选择" }],
        DefaultLogistics: [{ required: true, message: "请选择" }],
      },
      api: require("@/api/sy/opt").default,
      logistics: require("@/api/ba/logistics").default,
      AutoDeliveryInputIsShow: true,
    };
  },
  methods: {
    onBlur(row, type) {
      if (row[type] == null) row[type] = 0;
    },
    onFocus(row, type) {
      if (row[type] == 0) row[type] = null;
    },
    deliveryChange(){
        if(this.data.AutoDelivery=='true'){
             this.formRules.DefaultLogistics[0].required=true
             this.AutoDeliveryInputIsShow = true;
        }else{
             this.formRules.DefaultLogistics[0].required=false
             this.AutoDeliveryInputIsShow = false;

        }
    },
    getData() {
      this.logistics.list({ Status: 1 }).then((res) => {
        this.logisticsList=res.Data
      })
      this.api.list({ Code: "COMMON" }).then((res) => {
        if (res.Data.length == 0) {
          this.isNull = true;
        }
        res.Data.forEach((item) => {
          switch (item.OptText) {
            case "DisplayMode":
              this.data.displayModeId = item.OptId;
              this.data.displayMode = item.OptValue;
              break;
            case "TopUp":
              this.data.TopUpId = item.OptId;
              this.data.TopUp = item.OptValue;
              break;
            case "HybridPay":
              this.data.HybridPayId = item.OptId;
              this.data.HybridPay = item.OptValue;
              break;
            case "AutoDelivery":
              this.data.AutoDeliveryId = item.OptId;
              this.data.AutoDelivery = item.OptValue;
              break;
            case "AutoSend":
              this.data.AutoSendId = item.OptId;
              if(item.OptValue==0){
                  this.data.AutoSend = 0;
              }else{
                this.data.AutoSend = 1;
                this.data.AutoSendTime = item.OptValue;
              }
              break;
            case "AutoReview":
              this.data.AutoReviewId = item.OptId;
              if(item.OptValue==0){
                  this.data.AutoReview = 0;
              }else{
                this.data.AutoReview = 1;
                this.data.AutoReviewTime = item.OptValue;
              }
              break;
            case "AutoReceive":
              this.data.AutoReceiveId = item.OptId;
              if(item.OptValue==0){
                  this.data.AutoReceive = 0;
              }else{
                this.data.AutoReceive = 1;
                this.data.AutoReceiveTime = item.OptValue;
              }
              break;
            case "IsUpdateInventory":
              this.data.IsUpdateInventoryId = item.OptId;
              this.data.IsUpdateInventory = item.OptValue;
              break;
            case "DefaultLogistics":
              this.data.DefaultLogisticsId = item.OptId;
              this.data.DefaultLogistics = item.OptValue=='0'?'':item.OptValue;
              break;
            case "PurchaseAmount":
              this.data.PurchaseAmountId = item.OptId;
              this.data.PurchaseAmount = item.OptValue;
              break;
            case "Freight":
              this.data.FreightId = item.OptId;
              this.data.Freight = item.OptValue;
              break;
          }
        });
        if(this.data.AutoDelivery=='true'){
             this.formRules.DefaultLogistics[0].required=true
        }else{
             this.formRules.DefaultLogistics[0].required=false
        }
      });
    },
    submit() {
      let form = this.formValidate();
      form.then((valid) => {
        if (!valid) return;
        this.saveData = [
          {
            OptId: this.data.displayModeId,
            Code: "COMMON",
            OptValue: this.data.displayMode,
            OptText: "DisplayMode",
          },
          {
            OptId: this.data.TopUpId,
            Code: "COMMON",
            OptValue: this.data.TopUp,
            OptText: "TopUp",
          },
          {
            OptId: this.data.HybridPayId,
            Code: "COMMON",
            OptValue: this.data.HybridPay,
            OptText: "HybridPay",
          },
          {
            OptId: this.data.AutoDeliveryId,
            Code: "COMMON",
            OptValue: this.data.AutoDelivery,
            OptText: "AutoDelivery",
          },
          {
            OptId: this.data.DefaultLogisticsId,
            Code: "COMMON",
            OptValue: this.data.DefaultLogistics,
            OptText: "DefaultLogistics",
          },
          {
            OptId: this.data.PurchaseAmountId,
            Code: "COMMON",
            OptValue: this.data.PurchaseAmount,
            OptText: "PurchaseAmount",
          },
          {
            OptId: this.data.FreightId,
            Code: "COMMON",
            OptValue: this.data.Freight,
            OptText: "Freight",
          },
          {
            OptId: this.data.IsUpdateInventoryId,
            Code: "COMMON",
            OptValue: this.data.IsUpdateInventory,
            OptText: "IsUpdateInventory",
          },
        ];
        
        if(this.data.AutoSend==1){
            this.saveData.push({
              OptId: this.data.AutoSendId,
              Code: "COMMON",
              OptValue: this.data.AutoSendTime,
              OptText: "AutoSend",
            });
        }else{
             this.saveData.push({
              OptId: this.data.AutoSendId,
              Code: "COMMON",
              OptValue: '0',
              OptText: "AutoSend",
            });
        }
        if(this.data.AutoReview==1){
            this.saveData.push({
              OptId: this.data.AutoReviewId,
              Code: "COMMON",
              OptValue: this.data.AutoReviewTime,
              OptText: "AutoReview",
            });
        }else{
             this.saveData.push({
              OptId: this.data.AutoReviewId,
              Code: "COMMON",
              OptValue: '0',
              OptText: "AutoReview",
            });
        }
        if(this.data.AutoReceive==1){
            this.saveData.push({
              OptId: this.data.AutoReceiveId,
              Code: "COMMON",
              OptValue: this.data.AutoReceiveTime,
              OptText: "AutoReceive",
            });
        }else{
             this.saveData.push({
              OptId: this.data.AutoReceiveId,
              Code: "COMMON",
              OptValue: '0',
              OptText: "AutoReceive",
            });
        }
  
        // this.saveData.push({
        //   OptId: this.data.displayModeId,
        //   Code: "COMMON",
        //   OptValue: this.data.displayMode,
        //   OptText: "DisplayMode",
        // });

        if (this.isNull) {
          this.api.save(this.saveData).then((res) => {
            if (res.Code == 1) {
              this.$message.error(res.Msg);
            } else {
              this.isNull = false;
              this.$message.success("保存成功");
            }
          });
        } else {
          this.api.update(this.saveData).then((res) => {
            if (res.Code == 1) {
              this.$message.error(res.Msg);
            } else {
              this.$message.success("保存成功");
            }
          });
        }
      });
    },
    formValidate() {
      return this.$refs.form
        .validate()
        .then((valid) => {
          return valid;
        })
        .catch(() => {
          this.$notify({
            title: "提示",
            message: "请检查相关字段（红色）填写是否规范",
            type: "warning",
            position: "top-left",
          });
          return false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.item-title {
  margin-bottom: 10px;
  span {
    font-size: 18px;
    color: #606266;
  }
}
.item-content {
  margin-bottom: 30px;
  span {
    font-size: 14px;
    line-height: 29px;
    float: left;
    margin-right: 12px;
    color: #606266;
  }
}
.item-footer {
  margin-top: 10px;
  padding: 10px 20px 20px;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-top: 1px solid #e4e7ed;
}
.el-alert {
  padding-left: 5px;
  background: #cae2ff;
  color: #606266;
}
.el-form {
  padding: 0px 13px;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 0px;
  margin-right: 40px;
  float: left;
}

.opt_AutoDelivery_input{
  width: 50%;
  margin-left: 18px;
}
</style>